import { closeMenu } from "../../blocks/layout/header/menu/menu";
import { setupPulots } from "../../blocks/index/pulots";

const timeouts = [];
const main = document.querySelector(".main");
const links = document.querySelectorAll(".menu__link");

export default {
  enterAction: () => {
    return new Promise((resolve) => {
      main.classList.remove("main_hidden");

      links.forEach((link) => {
        if (
          link.pathname.split("/")[1] === window.location.pathname.split("/")[1]
        ) {
          link.classList.add("menu__link_current");
        } else {
          link.classList.remove("menu__link_current");
        }
      });

      setupPulots();

      timeouts.push(
        setTimeout(() => {
          resolve();
        }, 500)
      );
    });
  },
  exitAction: () => {
    return new Promise((resolve) => {
      main.scrollTo(0, 0);
      closeMenu();
      main.classList.add("main_hidden");

      timeouts.push(
        setTimeout(() => {
          resolve();
        }, 500)
      );
    });
  },
  breakAction: () => {
    timeouts.map(clearTimeout);
  }
};
